import React, { useCallback, useEffect, useState } from 'react';
import { faceIdVarMi, faceIdAcikMi, faceIdAc, faceIdKapat, faceIdNedenYok } from '../../utils/faceId';
import './AyarSatiri.css';

/*
  FACE ID AYARI
  -------------
  NEDEN VAR: Face ID yalnizca giristen sonra cikan teklif kartindan
  acilabiliyordu. Kart bir kez kacirildiginda ya da telefonda Face ID
  kullanilamadigi icin hic cikmadiginda, kullanicinin ozelligi acacak
  baska bir yolu yoktu ve neden calismadigini da goremiyordu.

  Burada hem acma/kapatma var hem de calismiyorsa SEBEBI yaziyor:
  uygulama eski surumse, telefonda Face ID tanimli degilse ya da
  tarayicidan bakiliyorsa ayri ayri soyluyor.
*/

const FaceIdAyari = ({ tur = 'personel' }) => {
  const [kullanilabilir, setKullanilabilir] = useState(null);  // null = bakiliyor
  const [acik, setAcik] = useState(faceIdAcikMi());
  const [calisiyor, setCalisiyor] = useState(false);
  const [mesaj, setMesaj] = useState('');
  const [sebep, setSebep] = useState('');

  const bak = useCallback(async () => {
    const v = await faceIdVarMi();
    setKullanilabilir(v);
    setSebep(faceIdNedenYok());
    setAcik(faceIdAcikMi());
  }, []);

  useEffect(() => { bak(); }, [bak]);

  const jetonuAl = () => {
    try {
      return tur === 'muvekkil'
        ? localStorage.getItem('muvekkilToken')
        : localStorage.getItem('token');
    } catch (e) {
      return null;
    }
  };

  const degistir = async () => {
    setMesaj('');
    setCalisiyor(true);
    try {
      if (acik) {
        await faceIdKapat();
        setAcik(false);
        setMesaj('Face ID girişi kapatıldı.');
      } else {
        const jeton = jetonuAl();
        if (!jeton) { setMesaj('Önce giriş yapmanız gerekiyor.'); return; }
        const oldu = await faceIdAc(jeton, tur);
        setAcik(oldu);
        setMesaj(oldu
          ? 'Açıldı. Bundan sonra yüzünüzle giriş yapabilirsiniz.'
          : 'Açılamadı. Doğrulama tamamlanmadı, tekrar deneyebilirsiniz.');
      }
    } finally {
      setCalisiyor(false);
    }
  };

  // Kart HER ZAMAN gosteriliyor. Once "kullanilamiyor" halinde
  // gizleniyordu; telefon cevap vermedigi durumlarda hic gorunmuyor ve
  // kullanicinin Face ID acacak bir yolu kalmiyordu.

  return (
    <div className={acik && kullanilabilir ? "fia-kutu fia-hazir" : "fia-kutu"}>
      <div className="fia-ust">
        <div className="fia-simge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
               strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 8V6a2 2 0 0 1 2-2h2" />
            <path d="M16 4h2a2 2 0 0 1 2 2v2" />
            <path d="M20 16v2a2 2 0 0 1-2 2h-2" />
            <path d="M8 20H6a2 2 0 0 1-2-2v-2" />
            <path d="M9 10v1M15 10v1" />
            <path d="M9 16c.9.7 1.9 1 3 1s2.1-.3 3-1" />
          </svg>
        </div>
        <div className="fia-metin">
          <strong>Face ID ile giriş</strong>
          <span>
            {kullanilabilir === null
              ? 'Kontrol ediliyor…'
              : kullanilabilir
                ? (acik
                  ? 'Açık. Bir dahaki açışınızda yüzünüzle giriş yaparsınız.'
                  : 'TC ve şifre yazmadan, yüzünüzle giriş yaparsınız. Şifreniz telefonda saklanmaz.')
                : `Şu an kullanılamıyor — ${sebep}.`}
          </span>
        </div>
      </div>

      {/* Dugme kullanilamaz durumda da duruyor: sebep gecici olabilir
          (telefon o an cevap vermemis olabilir), kullanici tekrar
          deneyebilsin. */}
      {kullanilabilir !== null && (
        <button
          type="button"
          className={acik ? 'fia-dugme fia-kapat' : 'fia-dugme'}
          onClick={kullanilabilir ? degistir : bak}
          disabled={calisiyor}
        >
          {calisiyor
            ? 'Doğrulanıyor…'
            : (!kullanilabilir ? 'Tekrar dene' : (acik ? 'Kapat' : 'Aç'))}
        </button>
      )}

      {mesaj && <p className="fia-mesaj">{mesaj}</p>}
    </div>
  );
};

export default FaceIdAyari;
